import React from 'react';

const CustomNotification = ({ show, message, type = 'info', onClose }) => {
  if (!show) return null;

  const getIcon = () => {
    switch (type) {
      case 'success': return '✅';
      case 'error': return '❌';
      case 'warning': return '⚠️';
      case 'info': return 'ℹ️';
      default: return 'ℹ️';
    }
  };

  const getColors = () => {
    switch (type) {
      case 'success': return 'from-green-500 to-emerald-600';
      case 'error': return 'from-red-500 to-rose-600';
      case 'warning': return 'from-yellow-500 to-orange-600';
      case 'info': return 'from-blue-500 to-indigo-600';
      default: return 'from-blue-500 to-indigo-600';
    }
  };

  return (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fade-in"
      onClick={onClose}
    >
      <div 
        className="bg-gray-900 rounded-2xl shadow-2xl border border-gray-700 max-w-md w-full transform animate-scale-in"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header with gradient */}
        <div className={`bg-gradient-to-r ${getColors()} p-4 rounded-t-2xl flex items-center gap-3`}>
          <span className="text-4xl">{getIcon()}</span>
          <div className="flex-1">
            <h3 className="text-white font-bold text-lg">
              {type === 'success' && 'Başarılı'}
              {type === 'error' && 'Hata'}
              {type === 'warning' && 'Uyarı'}
              {type === 'info' && 'Bilgi'}
            </h3>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-gray-300 text-base leading-relaxed whitespace-pre-line">
            {message}
          </p>
        </div>

        {/* Footer with button */}
        <div className="p-4 border-t border-gray-700 flex justify-end">
          <button
            onClick={onClose}
            className={`px-6 py-2.5 bg-gradient-to-r ${getColors()} text-white font-semibold rounded-xl hover:opacity-90 transition-all duration-200 transform hover:scale-105`}
          >
            Tamam
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomNotification;
